/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * TeamMemberDeletedDtoBase
 * auto generated base class for the model TeamMemberDeletedDtoModel.
 */
export const TeamMemberDeletedDtoModelBase = ModelBase
  .named('TeamMemberDeletedDto')
  .props({
    __typename: types.optional(types.literal("TeamMemberDeletedDto"), "TeamMemberDeletedDto"),
    /** UUID of the deleted team member */
    userUuid: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class TeamMemberDeletedDtoModelSelector extends QueryBuilder {
  get userUuid() { return this.__attr(`userUuid`) }
}
export function selectFromTeamMemberDeletedDto() {
  return new TeamMemberDeletedDtoModelSelector()
}

export const teamMemberDeletedDtoModelPrimitives = selectFromTeamMemberDeletedDto().userUuid
